module.exports = __webpack_public_path__ + "img/bike.1a96c506.png";